import { Endpoint } from "./BaseEndpoint";

export class SettingsEndpoint extends Endpoint {
  constructor() {
    super("module_settings");
  }
}
